import { render, staticRenderFns } from "./CreateClassGoals.vue?vue&type=template&id=7d701aac&scoped=true&"
import script from "./CreateClassGoals.vue?vue&type=script&lang=js&"
export * from "./CreateClassGoals.vue?vue&type=script&lang=js&"
import style0 from "./CreateClassGoals.vue?vue&type=style&index=0&id=7d701aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d701aac",
  null
  
)

export default component.exports